
import { defineComponent, ref, reactive, onActivated } from 'vue'
import { useRouter } from 'vue-router'
import { businessOptions } from '@/business'
import { User } from '@/types/clsUser'
import { UserInfo } from '@/types/clsUserInfo'
import { app } from '../main'

export default defineComponent({
  props: ['user'],
  setup (props, context) {
    const router = useRouter()
    const apiPath = app.config.globalProperties.api_path
    if (!props.user.login) {
      console.log('Can\'t access UserInfo for not login.')
      router.back()
    }
    const refFrmUserInfo: any = ref(null)
    const loginUser = new User()
    const frmUserInfo = reactive(new UserInfo())
    const message = reactive({
      msg: '',
      err: false,
      clear () {
        this.msg = ''
        this.err = false
      }
    })
    const options = businessOptions
    const validatePass1 = (rule: any, value: string, callback: any) => {
      if (value !== '') {
        if (value.length < 8) {
          callback(new Error('パスワードは8文字以上入力してください。'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    const validatePass2 = (rule: any, value: string, callback: any) => {
      if (value === '' && frmUserInfo.password !== '') {
        callback(new Error('確認用パスワードを入力してください。'))
      } else if (value !== frmUserInfo.password) {
        callback(new Error('2回入力されたパスワードが一致しません。'))
      } else {
        callback()
      }
    }
    const rules = {
      postal_code: [
        { required: true, message: '郵便番号を入力してください。', trigger: 'blur' },
        { min: 8, message: '文字数が不足しています（123-4567）。', trigger: 'blur' }
      ],
      address: [
        { required: true, message: '住所を入力してください。', trigger: 'blur' }
      ],
      tel: [
        { required: true, message: '電話番号を入力してください。', trigger: 'blur' },
        { min: 8, message: 'Length should be 8', trigger: 'blur' }
      ],
      business: [
        { required: true, message: '業種を選択してください。', trigger: 'change' }
      ],
      person_charge: [
        { required: true, message: 'ご担当者名を入力してください。', trigger: 'blur' }
      ],
      mail_address: [
        { required: true, message: 'メールアドレスを入力してください。', trigger: 'blur' }
      ],
      password: [
        { validator: validatePass1, trigger: 'blur' }
      ],
      checkPass: [
        { validator: validatePass2, trigger: 'blur' }
      ]
    }
    const cancel = () => {
      message.clear()
      router.push({ path: '/mypage' })
    }
    const handleChange = (value: any) => {
      console.log(value)
    }
    const getUserInfo = () => {
      fetch(apiPath + 'ajax/mypage.php', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(response => response.json())
        .then(json => {
          // console.log(json);
          if (json.result === 'failure') {
            frmUserInfo.clear()
            if (json.err_code === 9) {
              context.emit('login', new User())
            }
            throw new Error(json.error)
          }
          frmUserInfo.personCharge = json.person
          frmUserInfo.mailAddress = json.email
          frmUserInfo.corporateName = json.company
          frmUserInfo.postalCode = json.zipcode
          frmUserInfo.address = json.address
          frmUserInfo.tel = json.telno
          frmUserInfo.business = json.business
          frmUserInfo.csrf = props.user.csrf
          frmUserInfo.confFlg = json.conf_flg
          frmUserInfo.mailBackup = json.email
          loginUser.login = props.user.login
          loginUser.name = props.user.name
          loginUser.adminFlg = props.user.adminFlg
          loginUser.validmail = (json.conf_flg === '1')
          context.emit('login', loginUser)
        })
        .catch(error => {
          console.error(error)
          message.msg = error.message
          message.err = true
        })
    }
    const submitForm = () => {
      refFrmUserInfo.value.validate((valid: boolean) => {
        if (valid) {
          fetch(apiPath + 'ajax/update_user.php', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(frmUserInfo)
          }).then(response => response.json())
            .then(json => {
              // console.log(json);
              if (json.result === 'failure') {
                throw new Error(json.error)
              }
              if (json.affected_rows > 0) {
                message.msg = '更新しました。'
                message.err = false
                loginUser.login = props.user.login
                loginUser.name = frmUserInfo.personCharge
                loginUser.adminFlg = props.user.admin_flg
                loginUser.validmail = (json.conf_flg === '1')
                context.emit('login', loginUser)
                frmUserInfo.confFlg = loginUser.validmail
                if (json.conf_flg === '0') {
                  app.config.globalProperties.$notify.info({
                    title: 'Info',
                    message: 'メールアドレス確認用のメールを送信しました。'
                  })
                }
              } else {
                message.clear()
                console.log('Nothing to be update.')
              }
            })
            .catch(error => {
              console.error(error)
              message.msg = error.message
              message.err = true
            })
        }
      })
    }
    getUserInfo()
    onActivated(() => {
      getUserInfo()
    })

    return {
      refFrmUserInfo,
      frmUserInfo,
      options,
      rules,
      handleChange,
      submitForm,
      cancel,
      message
    }
  }
})
